<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .scroll-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: utils.in_rem(16px);
    padding: utils.in_rem(16px);
  }

  .page-info {
    @include mixins.body3-tooltip-and-caption();
  }
</style>

<script>
  import Button from "../../atoms/Button.svelte";

  let {
    page = $bindable(1),
    pageCount = null,
    skeleton = false,
    class: cls = "",
    style = "",
  } = $props();

  let canGoPrevious = $derived(page > 1);
  let canGoNext = $derived(!pageCount || page < pageCount);

  const onPrevious = () => {
    if (canGoPrevious) page -= 1;
  };

  const onNext = () => {
    if (canGoNext) page += 1;
  };
</script>

<div class="scroll-pagination {cls}" {style}>
  <Button
    kind="tertiary"
    leadingIcon="fa-chevron-left"
    size="xs"
    style="width: 2rem;"
    onclick={onPrevious}
    disabled={!canGoPrevious || skeleton}
    class={!canGoPrevious || skeleton ? "disabled" : ""}
  />

  <div class="page-info">
    {#if pageCount}
      Page {page} of {pageCount}
    {:else}
      Page {page}
    {/if}
  </div>

  <Button
    kind="tertiary"
    trailingIcon="fa-chevron-right"
    size="xs"
    style="width: 2rem;"
    onclick={onNext}
    disabled={!canGoNext || skeleton}
    class={!canGoNext || skeleton ? "disabled" : ""}
  />
</div>
